import { BrandService, ApiHttpService } from '../../services'
import { Unauthorized } from '../../helpers/unauthorized.handler'
export const BrandModule = {
    namespaced: true,
    state: {
        loading: false,
        Deleteloading: false,
        data: {
            columns: [
                {
                    label: 'ID',
                    field: 'id',
                    sort: 'asc',
                    clickable: true,
                    width : '100',
                },

                {
                    label: 'Code',
                    field: 'short',
                    sort: 'asc',
                    width: '100',
                },
                {
                    label: 'Name',
                    field: 'name',
                    sort: 'asc',
                    width: '200',
                },
              /*   {
                    label: 'Address',
                    field: 'address',
                    sort: 'asc',

                },
                {
                    label: 'Contact Person',
                    field: 'contact_person',
                    sort: 'asc',

                },
                {
                    label: 'Phone/Mobile',
                    field: 'contact_number',
                    sort: 'asc',

                },
                {
                    label: 'Email',
                    field: 'email',
                    sort: 'asc',

                },

                {
                    label: 'Website',
                    field: 'website',
                    sort: 'asc',

                }, */

                {
                    label: 'Status',
                    field: 'status',
                    sort: 'asc',
                    badge: true,
                    filters: [
                        { text: 'Active', value: '1' },
                        { text: 'Inactive', value: '0' },
                    ],
                    badgeFormatter: (value) => [true, 1, '1', 'true'].includes(value)
                        ? { label: 'Active', color: 'success' }
                        : { label: 'Inactive', color: 'default' },

                }


            ],
            rows: [],
        },
        length: 25,
        page: 0,
        total: 1,
        searchTerm: null,
        filters: {},

        formStatus: 'create',
        formRecord: {},

        brands: [],


    },
    actions: {

        async getBrands({},params) {
            return await new Promise((resolve,reject) => {
                ApiHttpService.getRequest('brands-groups', params).then((response) => {
                    resolve(response.data)
                }).catch(error => {
                    reject(error)
                })
            })
        },
        async GetBrands({ dispatch,commit },params) {
            return await new Promise((resolve) => {
                BrandService.get('/filter', params).then((response) => {
                    const res = []
                    if (response.data.length > 0) {
                        response.data.forEach((element) => {
                            const row = { label: element.name, value: element.mdbID, area: element.relationship.area, category: element.relationship.category, collections: element.relationship.collections }
                            res.push(row)
                        })
                    }
                    commit('setBrands',res)
                    resolve(res)
                }).catch(error => {
                    Unauthorized(dispatch, error)
                })
            })
        },
        async GetBrandErp({ dispatch,commit },params) {
            return await new Promise((resolve) => {
                BrandService.get('/filter-erp', params).then((response) => {
                    const res = []
                    if (response.data.length > 0) {

                            
                        response.data.forEach((element) => {
                            const row = { label: element.name, value: element.mdbID , parent : element.parent}
                            res.push(row)
                        })
                    }
                    commit('setBrands',res)
                    resolve(res)
                }).catch(error => {
                    Unauthorized(dispatch, error)
                })
            })
        },

        async GetArea({ dispatch }, params) {
            return await new Promise((resolve) => {
                BrandService.get('/filter-area', params).then((response) => {
                    const res = []
                    if (response.data.length > 0) {
                        response.data.forEach((element) => {
                            const row = { label: element.name, value: element.mdbID}
                            res.push(row)
                        })
                    }
                    resolve(res)
                }).catch(error => {
                    Unauthorized(dispatch, error)
                })
            })
        },

        async GetCategory ({dispatch }, params) {
            return await new Promise((resolve) => {
                BrandService.get('/filter-category', params).then((response) => {
                    resolve(response.data)
                }).catch(error => {
                    Unauthorized(dispatch, error)
                })
            })
        },

        async GetNextCode({ dispatch }) {
            return await new Promise((resolve) => {
                BrandService.get('/code', {}).then((response) => {
                    resolve(response.data)
                }).catch(error => {
                    Unauthorized(dispatch, error)
                })
            })
        },

        async asyncGetData({ rootState, commit, dispatch }) {
            const { loading, length, page, filters, searchTerm } = rootState.BrandModule
            return await new Promise((resolve) => {
                if (loading === false) {
                    commit('LoadingTrue')
                    const params = { length: length, page: page, term: searchTerm, filters: filters }
                    BrandService.get('\/data', params).then((response) => {
                        commit('SetPage', response.data.current_page)
                        commit('SetTotal', response.data.total)
                        commit('SetData', response.data.data)
                        commit('LoadingFalse')
                        resolve(response.data.data)
                    }).catch(error => {
                        //reject(error)
                        Unauthorized(dispatch, error)
                    })
                }
            })
        },



        async StoreRecord({ rootState, commit }, payload) {
            var self = this
            return await new Promise((resolve, reject) => {
                const loading = rootState.BrandModule.loading;
                if (!loading) {
                    commit('LoadingTrue')
                    BrandService.store(payload).then((response) => {
                        commit('LoadingFalse')
                        resolve(response.data)
                    }).catch((error) => {
                        commit('LoadingFalse')
                        reject(error)
                    })
                }
            })
        },
        UpdateRecord({ rootState, commit }, payload) {
            var self = this
            return new Promise((resolve, reject) => {
                const loading = rootState.BrandModule.loading;
                if (!loading) {
                    commit('LoadingTrue')
                    BrandService.put(payload).then((response) => {
                        commit('LoadingFalse')
                        resolve(response.data)
                    }).catch((error) => {
                        commit('LoadingFalse')
                        reject(error)
                    })
                }
            })
        },
        async DeleteRecord({ rootState, commit }, payload) {
            var self = this
            return await new Promise((resolve, reject) => {
                const loading = rootState.BrandModule.Deleteloading;
                if (!loading) {
                    commit('DeleteloadingTrue')
                    const tokens = [];
                    payload.forEach(element => {
                        tokens.push(element.token_id)
                    });
                    BrandService.deleteSelected(tokens).then((response) => {
                        commit('DeleteloadingFalse')
                        resolve(response.data)
                    }).catch((error) => {
                        commit('DeleteloadingFalse')
                        reject(error)
                    })
                }
            })
        }
    },
    mutations: {
        LoadingFalse: (state) => {
            state.loading = false
        },
        LoadingTrue: (state) => {
            state.loading = true
        },
        DeleteloadingFalse: (state) => {
            state.Deleteloading = false
        },
        DeleteloadingTrue: (state) => {
            state.Deleteloading = true
        },
        SetData(state, payload) {
            state.data.rows = payload
        },
        SetPage: (state, payload) => {
            state.page = payload
        },
        SetTotal: (state, payload) => {
            state.total = payload
        },
        SetLength: (state, payload) => {
            state.length = payload
        },
        SetCode: (state, payload) => {
            state.form.item_code = payload
        },

        SetFormStatusCreate: (state) => {
            state.formStatus = 'create'
        },

        SetFormStatusUpdate: (state) => {
            state.formStatus = 'update'
        },
        SetFormRecord: (state, payload) => {
            state.formRecord = payload
        },
        setBrands: (state, payload) => {
            state.brands = payload
        },

    },
    getters: {
        Loading: state => state.loading,
        Deleteloading: state => state.Deleteloading,
        dialogIsOpen: state => state.dialogIsOpen,
        data: state => state.data,
        page: state => state.page,
        total: state => state.total,
        length: state => state.length,
        form: state => state.form,
        columns: state => state.data.columns,
        FormStatus: state => state.formStatus,
        FormRecord: state => state.formRecord,
        brands: state => state.brands,
    }
}


